<div class="container-fluid kite-container page-oticket">

    <div class="row">
        <div class="col-6">
            <button type="button" class="btn-back kite-btn-back" aria-label="Close" [routerLink]="['/uco/business/megamenu2']">
                <i class="fa fa-step-backward" aria-hidden="true"></i>Back
            </button>
        </div>
        <div class="col-md-6">
            <h3 class="float-right mr-3">ECO CLEAN TICKET ORDER </h3>
        </div>
    </div>

<form [formGroup]="ticketForm"  (ngSubmit)="createTicket()">
    <div class="row mt-3">
        <div class="col-xl-2 col-md-4 mb-2 ">
            <label for="ticketClientId" class="label">Client ID</label>
            <input id="ticketClientId" class="form-control id-input" type="text" formControlName="client_id">
        </div>
        <div class="col-xl-6 col-md-8 mb-2">
            <label for="ticketClientName" class="label">Client name</label>
            <input id="ticketClientName" class="form-control" type="text" formControlName="client_name">
        </div>
        <div class="col-xl-2 col-md-4 mb-2 ">
            <label for="ticketTotalCost" class="label">Total ticket cost</label>
            <input id="ticketTotalCost" class="form-control id-input" type="number" formControlName="total_ticket_cost">
        </div>

        <div class="col-xl-2 col-md-4 mb-2 d-flex align-items-end">
            <button type="button" class="btn btn-danger w-100">Payment information</button>
        </div>

    </div>
    <div class="row">

        <fieldset class="col-xl-2">
            <legend class="label col-xl-12">Company group</legend>
            <div class="row">
            <div class="col-xl-5">
                <input class="form-check-input" type="radio" formControlName="location_jeting" id="ticketLocationJetingInside" value="inside">
                <label class="label" for="ticketLocationJetingInside">Inside</label>
            </div>
            <div class="col-xl-6">
                <input class="form-check-input" type="radio" formControlName="location_jeting" id="ticketLocationJetingOutside" value="outside">
                <label class="label" for="ticketLocationJetingOutside">Outside</label>
            </div>
            </div>

        </fieldset>

        <div class="col-xl-3 col-md-8">
            <label for="ticketPrimaryClient" class="label">Primary client name</label>
            <wj-auto-complete [placeholder]="'Select client'" id="ticketPrimaryClient" #clients class="form-control pb-0 pt-1"  [wjModelProperty]="'text'" formControlName="primary_client_name"></wj-auto-complete>
        </div>

        <div class="col-xl-3 col-md-2">
            <label for="ticketRequestedBy" class="label">Request by</label>
            <wj-auto-complete [placeholder]="'Select representant'" id="ticketRequestedBy" #people_business class="form-control pb-0 pt-1"  [wjModelProperty]="'text'" formControlName="requested_by" [itemsSource]="people" [displayMemberPath]="'name'"></wj-auto-complete>
        </div>

        <div class="col-xl-2 col-md-2">
            <label for="ticketFullname" class="label">Full name</label>
            <input id="ticketFullname" class="form-control" type="text" formControlName="fullname_request_by">
        </div>

        <div class="col-xl-2 col-md-2">
            <label for="ticketDateBegin" class="label">Date — begin written</label>
            <input id="ticketDateBegin" class="form-control id-input" type="date" formControlName="date_begin">
        </div>
    </div>
    <div class="container-fluid">
        <wj-tab-panel [selectedIndex]="0">
            <wj-tab>
                <a>GREASE TRAP - INTERCEPTOR</a>
                <div class="container-fluid mt-2">
                    <div class="row">
                        <div class="col-xl-2 col-md-8 mb-2">
                            <label for="ticketLocationType" class="label">Location type</label>
                            <wj-auto-complete [placeholder]="'Select type location'" id="ticketLocationType" #locationss class="form-control pb-0 pt-1"  [wjModelProperty]="'text'" formControlName="location_type" [itemsSource]="locations" [displayMemberPath]="'name'"></wj-auto-complete>
                        </div>
                        <div class="col-xl-1 col-md-8 mb-2">
                            <label for="ticketGallons" class="label">Gallons</label>
                            <input id="ticketGallons" type="number" class="form-control" formControlName="gallons">
                        </div>
                        <div class="col-xl-1 col-md-8 mb-2">
                            <label for="ticketPrice" class="label">Price</label>
                            <input id="ticketPrice" type="number" class="form-control" formControlName="price">
                        </div>
                        <div class="col-xl-2 col-md-8 mb-2">
                            <fieldset>
                                <legend class="label">Size</legend>
                                <div class="row">
                                    <div class="col-xl-4">
                                        <input id="ticketSizeL" type="number" class="form-control" placeholder="L" formControlName="size_l" aria-label="Size length (cm)">
                                    </div>
                                    <div class="col-xl-4">
                                        <input id="ticketSizeW" type="number" class="form-control" placeholder="W" formControlName="size_w" aria-label="Size width (cm)">
                                    </div>
                                    <div class="col-xl-4">
                                        <input id="ticketSizeH" type="number" class="form-control" placeholder="H" formControlName="size_h" aria-label="Size height (cm)">
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div class="col-xl-3 col-md-8 mb-2 row">
                            <label class="label">Available (time)</label>
                            <div class="col-xl-6 p-0">
                                <input class="form-check-input" type="radio" formControlName="available_grease" id="ticketAvailableGreaseAll" value="all">
                                <label class="label" for="ticketAvailableGreaseAll">Any time</label>
                            </div>
                            <div class="col-xl-6 p-0">
                                <input id="ticketAvailableGreaseTime" type="time" class="form-control" formControlName="available_grease" aria-label="Available time">
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-8 mb-2 row">
                            <label class="label">Frequency service</label>
                            <div class="col-xl-6 p-0">
                                <input class="form-check-input" type="radio" formControlName="frecuenty_grease" id="ticketGreaseFreqAll" value="all">
                                <label class="label" for="ticketGreaseFreqAll">One time</label>
                            </div>
                            <div class="col-xl-6 p-0">
                                <select id="ticketGreaseFreq" class="form-control" formControlName="frecuenty_grease" aria-label="Frequency service">
                                    <option value="">Select frequency</option>
                                    <option value="3">3 Months</option>
                                    <option value="6">6 Months</option>
                                    <option value="9">9 Months</option>
                                    <option value="12">12 Months</option>
                                </select>
                            </div>

                        </div>

                        <div class="col-xl-9">
                            <label for="ticketLocationDescription" class="label">Location description</label>
                            <input id="ticketLocationDescription" type="text" class="form-control" formControlName="location_descripcion">
                        </div>
                        <div class="col-xl-3 padding-custom-17">
                            <button class="btn btn-back kite-btn-back" type="button" (click)="addToGreaseFlex()">Add</button>
                        </div>

                        <div class="col-xl-12 mt-4 mb-2">
                            <!-- Tier 4.3: wj-flex-grid → app-kite-grid. Action column on
                                 the left carries the legacy info-circle icon (kept
                                 as a phantom button to preserve the visual layout
                                 — the original click handler `viewImage(modalViewImage,
                                 cell.item.ListID)` was a no-op because the template
                                 reference was never defined). -->
                            <app-kite-grid
                                [columnDefs]="greaseColumnDefs"
                                [rowData]="greaseSource()"
                                [totalRecords]="greaseSource().length"
                                [pageSize]="greaseSource().length || 1"
                                (cellClicked)="onCellClicked($event)">
                            </app-kite-grid>
                        </div>

                        <div class="col-xl-12">
                            <label for="ticketGreaseServiceDesc" class="label">Services description</label>
                            <textarea id="ticketGreaseServiceDesc" class="form-control" formControlName="grease_service_descriptions"></textarea>
                        </div>
                    </div>
                </div>
            </wj-tab>
            <wj-tab>
                <a>JETING</a>
                <div class="container-fluid mt-2">
                    <div class="row">

                        <fieldset class="col-xl-6 mb-2">
                            <legend class="label">Location</legend>
                            <div class="row">
                                <div class="col-xl-3">
                                    <div class="row">
                                    <div class="col-xl-5">
                                        <input class="form-check-input" type="radio" formControlName="location_jeting" id="ticketJetingInside" value="inside">
                                        <label class="label" for="ticketJetingInside">Inside</label>
                                    </div>
                                    <div class="col-xl-6">
                                        <input class="form-check-input" type="radio" formControlName="location_jeting" id="ticketJetingOutside" value="outside">
                                        <label class="label" for="ticketJetingOutside">Outside</label>
                                    </div>
                                    </div>

                                </div>

                                <div class="col-xl-3">
                                    <input id="ticketJetingDistance" type="number" class="form-control" placeholder="Distance (feet)" formControlName="distance" aria-label="Distance in feet">
                                </div>
                                <div class="col-xl-6">
                                    <wj-auto-complete [placeholder]="'Location type'" id="ticketJetingLocationType" #clients class="form-control pb-0 pt-1"  [wjModelProperty]="'text'" formControlName="location_type_jeting" [itemsSource]="locations" [displayMemberPath]="'name'"></wj-auto-complete>
                                </div>
                            </div>
                        </fieldset>
                        <div class="col-xl-2 mb-2">
                            <label for="ticketJetingPrice" class="label">Price</label>
                                <input id="ticketJetingPrice" type="number" class="form-control" placeholder="$0.00" formControlName="jeting_price">
                        </div>

                        <div class="col-xl-2 mb-2 row">
                            <label class="label">Available (time)</label>
                            <div class="col-xl-6 p-0">
                                <input class="form-check-input" type="radio" formControlName="available_jeting" id="ticketAvailableJetingAll" value="all">
                                <label class="label" for="ticketAvailableJetingAll">Any time</label>
                            </div>
                            <div class="col-xl-6 p-0">
                                <input id="ticketAvailableJetingTime" type="time" class="form-control" formControlName="available_jeting" aria-label="Available time">
                            </div>
                        </div>

                        <div class="col-xl-2 mb-2 row">
                            <label class="label">Frequency service</label>
                            <div class="col-xl-6 p-0">
                                <input class="form-check-input" type="radio" formControlName="frecueny_jeting" id="ticketJetingFreqAll" value="all">
                                <label class="label" for="ticketJetingFreqAll">One time</label>
                            </div>
                            <div class="col-xl-6 p-0">
                                <select id="ticketJetingFreq" class="form-control" formControlName="frecueny_jeting" aria-label="Frequency service">
                                    <option value="">Select frequency</option>
                                    <option value="3">3 Months</option>
                                    <option value="6">6 Months</option>
                                    <option value="9">9 Months</option>
                                    <option value="12">12 Months</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-xl-2 mb-2 float-right">
                            <button class="btn btn-back kite-btn-back" (click)="addJetingFlex();">Add</button>
                        </div>

                        <div class="col-xl-12 mt-4 mb-2">
                            <!-- Tier 4.3: wj-flex-grid → app-kite-grid. Same phantom
                                 info-circle action as the grease grid above. -->
                            <app-kite-grid
                                [columnDefs]="jetingColumnDefs"
                                [rowData]="jetingSource()"
                                [totalRecords]="jetingSource().length"
                                [pageSize]="jetingSource().length || 1"
                                (cellClicked)="onCellClicked($event)">
                            </app-kite-grid>
                        </div>

                        <div class="col-xl-12">
                            <label for="ticketJetingServiceDesc" class="label">Services description</label>
                            <textarea id="ticketJetingServiceDesc" class="form-control" formControlName="jeting_service_description"></textarea>
                        </div>
                    </div>
                </div>
            </wj-tab>
            <wj-tab>
                <a>CLEANING SERVICES</a>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-xl-2">
                            <label for="ticketCleanArea" class="label">Area size</label>
                            <input id="ticketCleanArea" type="number" class="form-control" placeholder="0.000" formControlName="clean_area">
                        </div>

                        <div class="col-xl-3 mb-2 row">
                            <label class="label">Available (time)</label>
                            <div class="col-xl-6 p-0">
                                <input class="form-check-input" type="radio" formControlName="available_clean" id="ticketAvailableCleanAll" value="all">
                                <label class="label" for="ticketAvailableCleanAll">Any time</label>
                            </div>
                            <div class="col-xl-6 p-0">
                                <input id="ticketAvailableCleanTime" type="time" class="form-control" formControlName="available_clean" aria-label="Available time">
                            </div>
                        </div>

                        <div class="col-xl-3 mb-2 row">
                            <label class="label">Frequency service</label>
                            <div class="col-xl-6 p-0">
                                <input class="form-check-input" type="radio" formControlName="frecuency_clean" id="ticketCleanFreqAll" value="all">
                                <label class="label" for="ticketCleanFreqAll">One time</label>
                            </div>
                            <div class="col-xl-6 p-0">
                                <select id="ticketCleanFreq" class="form-control float-left" formControlName="frecuency_clean" aria-label="Frequency service">
                                    <option value="">Select frequency</option>
                                    <option value="3">3 Months</option>
                                    <option value="6">6 Months</option>
                                    <option value="9">9 Months</option>
                                    <option value="12">12 Months</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-xl-4 mb-2">
                            <label for="ticketCleanPictures" class="label">Import pictures</label>
                            <input id="ticketCleanPictures" type="file" class="form-control">
                        </div>

                        <div class="col-xl-12">
                            <label for="ticketCleanServiceDesc" class="label">Services description</label>
                            <textarea id="ticketCleanServiceDesc" cols="30" rows="5" class="form-control" formControlName="clean_service_description"></textarea>
                        </div>
                    </div>
                </div>
            </wj-tab>
        </wj-tab-panel>
    </div>

    <div class="row">
        <button class="btn-back kite-btn-back" type="submit">Create ticket</button>
    </div>

</form>

</div>
